import { useQuery } from "@tanstack/react-query";
import Spinner from "components/Spinner";
import { IReadingAssessment } from "components/useReadingAssessmentResponse";
import { Link } from "react-router-dom";
import AuthService from "services/AuthService";
import HTTPClient from "services/HTTPClient";

const useReadingAssessments = (grade) => {
    return useQuery<IReadingAssessment[]>(['reading-assessment', grade], async () => {
        let query = {
            grade,
            populate: "image",
            sort: "id:desc",
            "pagination[limit]": -1,
            "fields[0]": "id",
            "fields[1]": "title",
        }
        const url = `/api/reading-assessments`
        let response = await HTTPClient.get().getJSONResult(url, query)
        return response.data
    });
};

export default function ReadingAssessments() {
    let grade = AuthService.getGrade()
    const { data: readingAssessments, isLoading, error, refetch } = useReadingAssessments(grade)

    if (isLoading) {
        return <div className="center my-5">
            <Spinner />
        </div>
    }
    return (
        <div>
            <h4 className='is-size-4 mb-3'>
                <strong>Assigned Lessons</strong>
            </h4>
            <div className="columns" style={{ flexWrap: "wrap", gap: "10px 0px" }}>
                {readingAssessments?.map(ras => {
                    return <div key={ras.id} className="column is-half" style={{ height: 200 }}>
                        <ReadingAssessment assessment={ras} />
                    </div>
                })}
            </div>
        </div>
    )
}

function ReadingAssessment({ assessment }: { assessment: IReadingAssessment }) {
    return <Link to={`/assessment/${assessment.id}`}>
        <div className="card mb-3 d-flex c-pointer" style={{ borderRadius: "20px" }}>
            <div className="mr-2">
                <div style={{
                    backgroundImage: `url(${assessment.image?.url})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    height: 200,
                    width: 200,
                    borderRadius: "20px 0 0 20px"
                }} />
            </div>
            <div className="p-5 center">
                <h4 className='is-size-4 mb-3'>
                    <strong>{assessment.title}</strong>
                </h4>
            </div>
        </div>
    </Link>
}